export default "__VITE_ASSET__BnqAhFr9__"